import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16.0035 1V3.00396L14 3.00424V1.00027L16.0035 1ZM10.0524 2.63458L11.4699 4.05185L10.0529 5.4685L8.63643 4.05168L10.0524 2.63458ZM19.9515 2.63476L21.3674 4.05132L19.9516 5.46846L18.5337 4.05202L19.9515 2.63476ZM10.9588 6.05557C11.8672 4.81094 13.3383 4.00012 15 4.00012C17.7614 4.00012 20 6.2387 20 9.00012C20 10.0022 19.7046 10.936 19.1971 11.7183C20.2982 12.6885 21 14.0925 21 15.6668C21 18.6476 18.5017 21.0001 15.5 21.0001H5.6C3.0954 21.0001 1 19.0356 1 16.5335C1 14.7036 2.12452 13.1582 3.70565 12.4626C3.70189 12.3755 3.7 12.288 3.7 12.2001C3.7 8.74073 6.60128 6.00013 10.1 6.00013C10.3908 6.00013 10.6775 6.01898 10.9588 6.05557ZM10.1 8.00013C7.63404 8.00013 5.7 9.91577 5.7 12.2001C5.7 12.4623 5.72505 12.718 5.77273 12.9655L5.95683 13.921L5.00676 14.1311C3.83155 14.3911 3 15.3905 3 16.5335C3 17.8605 4.12815 19.0001 5.6 19.0001H15.5C17.4689 19.0001 19 17.4725 19 15.6668C19 14.4514 18.3143 13.3703 17.259 12.7844C16.7444 12.4986 16.1446 12.3335 15.5 12.3335C15.4803 12.3335 15.4607 12.3336 15.4411 12.3339L14.5868 12.3473L14.4403 11.5056C14.158 9.88428 12.8892 8.54957 11.2061 8.13376C10.8538 8.04674 10.4834 8.00013 10.1 8.00013ZM21 8.00004L23.0039 8.00028V10.0037H21V8.00004Z"}}]};

const CloudySunnyFilled = Vue.extend<IconProps>({
  name: 'CloudySunnyFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'cloudy-sunny-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default CloudySunnyFilled;
